export default (apiFetch) => async ({ page = 1, exclude = [], size = 8, range_min = 0, range_max = 3000, region = '', order_by = '', land_use = '', price = '' }) => {
  let queryParams = [];

  if (exclude.length) {
    queryParams.push(`exclude=${exclude.join(",")}`);
  }
  if (size >= 0) {
    queryParams.push(`size=${size}`);
  }

  queryParams.push(`range_min=${range_min}`);
  queryParams.push(`range_max=${range_max}`);

  if (region) {
    queryParams.push(`region=${region}`);
  }

  if (order_by) {
    queryParams.push(`order_by=${order_by}`);
  }

  if (price) {
    queryParams.push(`price=${price}`);
  }

  if (land_use) {
    queryParams.push(`land_use=${land_use}`);
  }


  if (queryParams.length) {
    queryParams = `?${queryParams.join("&")}`;
  } else {
    queryParams = "";
  }

  const response = await apiFetch({
    endpoint: `properties/${page}/${queryParams}`,
    method: "GET",
    headers: {},
  });

  return await response.json();
};
